<div class="flex flex-col">
  <label class="soft-label soft-label-top">
    {{ definition?.title }}
    @if (definition.required | booleanRule: form.value) {
      <span
        class="required-indicator"
        >*</span
        >
      }
    </label>
    <soft-list [formControl]="form|formControl:definition.name" #list>
      <ng-template let-item="item">
        <soft-dynamic-object-value
          [definition]="definition.definition"
          [value]="item"
        ></soft-dynamic-object-value>
      </ng-template>
    </soft-list>
    <div class="flex flex-row justify-end">
      @if (list.selected) {
        <span>
          <button
            class="soft-button link danger"
            (click)="onDeleteClick(list.selected)"
            >
            <i class="fa-regular fa-delete-left"></i>
            Löschen
          </button>
          |
        </span>
      }
      @if (list.selected) {
        <span>
          <button class="soft-button link" (click)="onEditClick(list.selected)">
            <i class="fa-regular fa-pen-to-square"></i>
            Bearbeiten
          </button>
          |
        </span>
      }
      <span>
        <button class="soft-button link" (click)="onAddClick()">
          <i class="fa-regular fa-plus"></i>
          Hinzufügen
        </button>
      </span>
    </div>
    @if (form.controls[definition.name].touched) {
      <soft-validation-container
        class="soft-property-validation"
        [validation]="form | combineValidations: definition.name"
      ></soft-validation-container>
    }
  </div>
  {{ form.value | json }}
  {{ definition | json }}
